import PayoutAddressButtons from './PayoutAddressButtons';
import StatusBadge from './StatusBadge';
import WorkerDetailLink from './WorkerDetailLink';
import WorkerLabels from './WorkerLabels';
import WorkerStateLabel from './WorkerStateLabel';
import WorkerWarrantyHealth from './WorkerWarrantyHealth';

const FormatterIndex = {
  PayoutAddressButtons,
  StatusBadge,
  WorkerDetailLink,
  WorkerLabels,
  WorkerStateLabel,
  WorkerWarrantyHealth,
};

export default FormatterIndex;